import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import cleanDirectory from 'genesis-suite/utils/cleanDirectory'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'

import App from './App'
import './lib/globalTypes'
import { theme } from './lib/theme'
import * as serviceWorker from './serviceWorker'
import { AuthProvider } from './components/contexts/AuthContext'

createRoot(document.getElementById('root')).render(
    <Router basename={cleanDirectory(process.env.PUBLIC_URL)}>
        <AuthProvider>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </StyledEngineProvider>
        </AuthProvider>
    </Router>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
